// Theme system — ZZYON Brand Manual v1.0 (oficial)
// Cores e tokens extraídos de ZZYON-Manual-da-Marca-v1.0
// Tagline: "Inteligência em órbita"

const TOKENS_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=JetBrains+Mono:wght@400;500&display=swap');

:root {
  /* ========== ZZYON BRAND v1.0 — palette oficial ========== */
  --zzy-navy:        #0A0E27;
  --zzy-navy-deep:   #05081C;
  --zzy-navy-soft:   #161A38;
  --zzy-blue:        #3B6EFF;
  --zzy-blue-light:  #6B8FFF;
  --zzy-blue-deep:   #1E3FCC;
  --zzy-ink:         #0A0E27;
  --zzy-ink-soft:    #3B4063;
  --zzy-ink-mute:    #8086A8;
  --zzy-line:        #E1E5F0;
  --zzy-bg-soft:     #F5F7FA;
  --zzy-white:       #FFFFFF;
  --zzy-orbit:       #6B8FFF;

  /* Aliases pragmáticos pra componentes (mapeiam sobre o brand) */
  --zzy-midnight:       var(--zzy-navy);
  --zzy-midnight-deep:  var(--zzy-navy-deep);
  --zzy-deep:           var(--zzy-blue-deep);
  --zzy-sky:            var(--zzy-blue);
  --zzy-sky-strong:     var(--zzy-blue-light);
  --zzy-sky-soft:       rgba(59,110,255,0.12);
  --zzy-mist:           var(--zzy-white);
  --zzy-cloud:          rgba(255,255,255,0.78);
  --zzy-ink-on-dark:    rgba(255,255,255,0.92);
  --zzy-text-mute-dark: rgba(255,255,255,0.55);

  --zzy-primary:  var(--zzy-navy);
  --zzy-accent:   var(--zzy-blue);
  --zzy-bg:       var(--zzy-navy);
  --zzy-surface:  rgba(22, 26, 56, 0.55);
  --zzy-surface-solid: var(--zzy-navy-soft);
  --zzy-text:     var(--zzy-white);
  --zzy-text-mute:rgba(255,255,255,0.55);
  --zzy-border:   rgba(255,255,255,0.06);
  --zzy-border-strong: rgba(255,255,255,0.12);

  /* Estados */
  --zzy-success:  #1AB36D;
  --zzy-warning:  #F59E0B;
  --zzy-danger:   #E53935;
  --zzy-info:     var(--zzy-blue-light);

  /* Geometria — escalas conforme Brand Manual */
  --zzy-radius:        12px;
  --zzy-radius-sm:     6px;
  --zzy-radius-md:     8px;
  --zzy-radius-lg:     14px;
  --zzy-radius-pill:   999px;
  --zzy-shadow:        0 12px 40px rgba(0,0,0,0.45);
  --zzy-shadow-glow:   0 0 32px rgba(59,110,255,0.32);
  --zzy-shadow-card:   0 1px 0 rgba(255,255,255,0.04) inset, 0 24px 56px rgba(0,0,0,0.35);
  --zzy-blur:          saturate(140%) blur(20px);

  /* Motion */
  --zzy-ease:          cubic-bezier(0.22, 1, 0.36, 1);
  --zzy-fast:          .15s var(--zzy-ease);
  --zzy-base:          .3s var(--zzy-ease);
  --zzy-slow:          .6s var(--zzy-ease);

  /* Typography — Inter com OpenType features oficiais ZZYON */
  --zzy-font:     'Inter','Helvetica Neue',Arial,sans-serif;
  --zzy-font-mono:'JetBrains Mono', ui-monospace, monospace;
  --zzy-font-features: "ss01","cv11";
}

* { box-sizing: border-box; }

html, body {
  margin: 0; padding: 0;
  background: var(--zzy-navy);
  color: var(--zzy-white);
  font-family: var(--zzy-font);
  font-size: 14px;
  line-height: 1.55;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: -0.005em;
  font-feature-settings: var(--zzy-font-features);
}

/* Background cinematográfico — gradientes oficiais do Cover do Manual */
body {
  background:
    radial-gradient(120% 80% at 80% 50%, rgba(59,110,255,0.18) 0%, rgba(59,110,255,0) 60%),
    radial-gradient(80% 60% at 10% 100%, rgba(30,63,204,0.18) 0%, rgba(30,63,204,0) 60%),
    var(--zzy-navy-deep);
  background-attachment: fixed;
  min-height: 100vh;
}

a { color: inherit; text-decoration: none; transition: opacity var(--zzy-fast); }
a:hover { opacity: .82; }

button { font-family: inherit; cursor: pointer; }

::selection { background: var(--zzy-blue); color: var(--zzy-white); }

::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.08); border-radius: 4px; }
::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.16); }

/* ==================== CARDS ==================== */
.zzy-card {
  background: var(--zzy-surface);
  backdrop-filter: var(--zzy-blur);
  -webkit-backdrop-filter: var(--zzy-blur);
  border: 1px solid var(--zzy-border);
  border-radius: var(--zzy-radius);
  padding: 24px;
  box-shadow: var(--zzy-shadow-card);
  transition: border-color var(--zzy-base), transform var(--zzy-base);
}
.zzy-card:hover { border-color: var(--zzy-border-strong); }

.zzy-card--solid {
  background: var(--zzy-surface-solid);
  backdrop-filter: none;
}

.zzy-card--feature {
  background: linear-gradient(135deg, rgba(59,110,255,0.10) 0%, rgba(30,63,204,0.20) 100%);
  border-color: rgba(59,110,255,0.18);
}

/* ==================== BOTÕES ==================== */
.zzy-btn {
  background: var(--zzy-blue);
  color: var(--zzy-white);
  border: 0;
  padding: 11px 22px;
  border-radius: var(--zzy-radius-md);
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.01em;
  transition: transform var(--zzy-fast), box-shadow var(--zzy-base), background var(--zzy-fast);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.zzy-btn:hover {
  background: var(--zzy-blue-light);
  transform: translateY(-1px);
  box-shadow: var(--zzy-shadow-glow);
}
.zzy-btn:active { transform: translateY(0); }

.zzy-btn--ghost {
  background: transparent;
  color: var(--zzy-white);
  border: 1px solid var(--zzy-border-strong);
}
.zzy-btn--ghost:hover {
  background: rgba(255,255,255,0.04);
  border-color: rgba(255,255,255,0.22);
  box-shadow: none;
  transform: none;
}

.zzy-btn--minimal {
  background: transparent;
  color: var(--zzy-text-mute);
  padding: 8px 14px;
  font-size: 13px;
}
.zzy-btn--minimal:hover {
  background: rgba(255,255,255,0.04);
  color: var(--zzy-white);
  box-shadow: none;
  transform: none;
}

/* ==================== INPUTS ==================== */
.zzy-input {
  width: 100%;
  padding: 13px 16px;
  border-radius: var(--zzy-radius-md);
  background: rgba(255,255,255,0.03);
  border: 1px solid var(--zzy-border);
  color: var(--zzy-white);
  font: 400 14px/1 var(--zzy-font);
  outline: none;
  transition: border-color var(--zzy-fast), background var(--zzy-fast);
}
.zzy-input:focus {
  border-color: var(--zzy-blue);
  background: rgba(255,255,255,0.05);
}

/* ==================== TYPOGRAPHY (escalas Brand Manual) ==================== */
.zzy-eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: var(--zzy-blue-light);
}

.zzy-h1 {
  font-size: clamp(36px, 6vw, 72px);
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.05;
  color: var(--zzy-white);
}

.zzy-h2 {
  font-size: clamp(24px, 3.5vw, 36px);
  font-weight: 800;
  letter-spacing: -0.018em;
  line-height: 1.05;
  color: var(--zzy-white);
}

.zzy-h3 {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--zzy-white);
}

.zzy-h4 {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.005em;
  color: var(--zzy-white);
}

.zzy-lead {
  font-size: 16px;
  line-height: 1.45;
  color: var(--zzy-cloud);
}

.zzy-micro {
  font-size: 10px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--zzy-text-mute);
}

.zzy-mono { font-family: var(--zzy-font-mono); }

/* ==================== PILL & TAG (oficial do Manual) ==================== */
.zzy-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid var(--zzy-blue-light);
  color: var(--zzy-blue-light);
  border-radius: var(--zzy-radius-pill);
  font-size: 10px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-weight: 600;
}

.zzy-tag {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 4px;
  background: rgba(59,110,255,0.12);
  color: var(--zzy-blue-light);
  font-size: 10px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-weight: 700;
}

/* ==================== SISTEMA VISUAL ORBITAL (Brand Manual + motion) ==================== */
.zzy-orbit-bg {
  position: absolute;
  pointer-events: none;
  opacity: 0.5;
  width: 900px;
  height: 900px;
  right: -350px;
  top: 50%;
  transform: translateY(-50%);
  z-index: -1;
}
.zzy-orbit-bg .o {
  position: absolute; left: 50%; top: 50%;
  border: 1px solid rgba(107,143,255,0.35);
  border-radius: 50%;
}
.zzy-orbit-bg .o1 { width: 100%; height: 100%; margin-left: -50%; margin-top: -50%; animation: zzyOrbitSpin 60s linear infinite; }
.zzy-orbit-bg .o2 { width: 78%;  height: 78%;  margin-left: -39%; margin-top: -39%; animation: zzyOrbitSpin 45s linear infinite reverse; }
.zzy-orbit-bg .o3 { width: 55%;  height: 55%;  margin-left: -27.5%; margin-top: -27.5%; animation: zzyOrbitSpin 30s linear infinite; }
.zzy-orbit-bg .o4 { width: 30%;  height: 30%;  margin-left: -15%; margin-top: -15%; animation: zzyOrbitSpin 18s linear infinite reverse; }

/* Dots viajam com os anéis (anchor + rotação) */
.zzy-orbit-bg .dot-anchor {
  position: absolute;
  left: 50%; top: 50%;
  transform-origin: 0 0;
}
.zzy-orbit-bg .dot-anchor.r1 { animation: zzyOrbitSpin 60s linear infinite; }
.zzy-orbit-bg .dot-anchor.r2 { animation: zzyOrbitSpin 45s linear infinite reverse; }
.zzy-orbit-bg .dot-anchor.r3 { animation: zzyOrbitSpin 30s linear infinite; }
.zzy-orbit-bg .dot-anchor.r4 { animation: zzyOrbitSpin 18s linear infinite reverse; }
.zzy-orbit-bg .dot {
  position: absolute;
  width: 10px; height: 10px;
  border-radius: 50%;
  background: var(--zzy-blue);
  box-shadow: 0 0 16px rgba(59,110,255,0.8);
  margin-left: -5px; margin-top: -5px;
  animation: zzyOrbitPulse 3s ease-in-out infinite;
}

@keyframes zzyOrbitSpin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
@keyframes zzyOrbitPulse {
  0%, 100% { box-shadow: 0 0 8px rgba(59,110,255,0.5);  opacity: 0.7; }
  50%      { box-shadow: 0 0 24px rgba(59,110,255,1);   opacity: 1;   }
}

@media (prefers-reduced-motion: reduce) {
  .zzy-orbit-bg .o, .zzy-orbit-bg .dot-anchor, .zzy-orbit-bg .dot { animation: none !important; }
}

/* ==================== ANIMAÇÕES ==================== */
@keyframes zzyFadeUp {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes zzyFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.zzy-fade-up   { animation: zzyFadeUp .5s var(--zzy-ease) both; }
.zzy-fade-in   { animation: zzyFadeIn .4s var(--zzy-ease) both; }
.zzy-fade-up.delay-1 { animation-delay: .08s; }
.zzy-fade-up.delay-2 { animation-delay: .16s; }
.zzy-fade-up.delay-3 { animation-delay: .24s; }
.zzy-fade-up.delay-4 { animation-delay: .32s; }
`;

let _injected = false;
export function injectBaseStyles() {
  if (_injected || typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.id = 'zzy-tokens';
  style.textContent = TOKENS_CSS;
  document.head.appendChild(style);
  _injected = true;
}

/**
 * Apply per-tenant branding overrides on top of base ZZYON Brand Manual tokens.
 */
export function applyTheme(branding = {}) {
  const root = document.documentElement;
  if (branding.cor_primary) root.style.setProperty('--zzy-primary', branding.cor_primary);
  if (branding.cor_accent)  root.style.setProperty('--zzy-accent',  branding.cor_accent);
  if (branding.app_name)    document.title = branding.app_name + ' · ZZYON';

  if (branding.favicon_url) {
    let icon = document.querySelector('link[rel="icon"]');
    if (!icon) {
      icon = document.createElement('link');
      icon.rel = 'icon';
      document.head.appendChild(icon);
    }
    icon.href = branding.favicon_url;
  }
  window.__zzyBranding = branding;
}

/**
 * Renders the Sistema Visual Orbital background (4 concentric rings + 4 pulsing dots).
 * Usage:  document.body.appendChild(createOrbitBackground());
 */
export function createOrbitBackground() {
  const div = document.createElement('div');
  div.className = 'zzy-orbit-bg';
  // 4 anéis girando + 4 dots ancorados em cada anel (giram junto)
  // Cada dot fica numa posição radial diferente (raio = % do anel correspondente)
  div.innerHTML = `
    <div class="o o1"></div>
    <div class="o o2"></div>
    <div class="o o3"></div>
    <div class="o o4"></div>
    <div class="dot-anchor r1"><div class="dot" style="transform: translate(450px, 0)"></div></div>
    <div class="dot-anchor r2"><div class="dot" style="transform: translate(0, -351px)"></div></div>
    <div class="dot-anchor r3"><div class="dot" style="transform: translate(-247px, 0)"></div></div>
    <div class="dot-anchor r4"><div class="dot" style="transform: translate(95px, 117px)"></div></div>
  `;
  return div;
}
